import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=26b6acc6&"
import script from "./academy.vue?vue&type=script&lang=js&"
export * from "./academy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports